import { render, staticRenderFns } from "./AccessibleLoaders.vue?vue&type=template&id=06bf39ad&scoped=true&"
import script from "./AccessibleLoaders.vue?vue&type=script&lang=js&"
export * from "./AccessibleLoaders.vue?vue&type=script&lang=js&"
import style0 from "./AccessibleLoaders.vue?vue&type=style&index=0&id=06bf39ad&scoped=true&lang=css&"
import style1 from "./AccessibleLoaders.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bf39ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VProgressCircular,VProgressLinear,VSkeletonLoader})
